import React, { useCallback, useEffect, useState } from "react";
import { Helmet } from "react-helmet";

import NotificationsActiveRoundedIcon from "@mui/icons-material/NotificationsActiveRounded";
import CheckRoundedIcon from "@mui/icons-material/CheckRounded";
import WarningRoundedIcon from "@mui/icons-material/WarningRounded";
import NewReleasesRoundedIcon from "@mui/icons-material/NewReleasesRounded";
import ForumRoundedIcon from "@mui/icons-material/ForumRounded";

import axiosInstance from "../../api/axiosInstance";
import moment from "moment";
import "moment/locale/de";

import "./logging.scss";

moment.locale("de");

const Logging = () => {
    const [logs, setLogs] = useState({});
    const [isLoading, setLoading] = useState(true);

    const fetchData = useCallback(async () => {
        try {
            const res = await axiosInstance.get("logging");
            setLogs(res.data);
        } catch (err) {
            console.error("Fehler beim Laden der Logs:", err);
        } finally {
            setLoading(false);
        }
    }, []);

    useEffect(() => {
        fetchData();

        const interval = setInterval(fetchData, 10000);

        return () => clearInterval(interval);
    }, [fetchData]);

    function getNotificationIcon(type) {
        switch (type) {
            case 'info':
                return <NotificationsActiveRoundedIcon />;

            case 'success':
                return <CheckRoundedIcon style={{ background: "#007bff" }} />;

            case 'warning':
                return <WarningRoundedIcon style={{ background: "#ff7700" }} />;

            case 'error':
                return <NewReleasesRoundedIcon style={{ background: "#cd071e" }} />;

            default:
                return <ForumRoundedIcon />;
        }
    }

    if (isLoading) {
        return <div className="loading" />;
    }

    return (
        <div className="logging">
            <Helmet>
                <title>Logging</title>
            </Helmet>

            <div className="container">
                <div className="header">
                    <h1>Logging</h1>
                </div>

                <div className="layout">
                    {Object.keys(logs).length === 0 ? (
                        <div className="logsEmpty">
                            Keine Logs
                        </div>
                    ) : (
                        Object.entries(logs).map(([date, dailyLogs]) => (
                            <div className="logGroup" key={date}>
                                <h5 className="logDate">
                                    {moment(date).format("LL")}
                                </h5>

                                <ul>
                                    {dailyLogs.map((i) => (
                                        <li key={i.id}>
                                            <div className="left">
                                                {getNotificationIcon(i.type)}

                                                <div className="text">
                                                    <h5>{i.title}</h5>
                                                    <p>{i.message}</p>
                                                </div>
                                            </div>

                                            <div className="right">
                                                <span>{i.name}</span>

                                                <span className="time">
                                                    {moment(i.createdAt).format(
                                                        "DD. MMM HH:mm [Uhr]"
                                                    )}
                                                </span>
                                            </div>
                                        </li>
                                    ))}
                                </ul>
                            </div>
                        ))
                    )}
                </div>
            </div>
        </div>
    );
};

export default Logging;